export const EditSvg = (props: any) => {
  return (
    <svg
      {...props}
      width="41"
      height="41"
      viewBox="0 0 41 41"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20 36C28.8366 36 36 28.8366 36 20C36 11.1634 28.8366 4 20 4C11.1634 4 4 11.1634 4 20C4 28.8366 11.1634 36 20 36ZM28.6947 14.1699L25.8138 11.289C25.6193 11.0946 25.3043 11.0937 25.1088 11.287L21.8916 14.4665L25.5692 18.0025L28.6947 14.877C28.8899 14.6818 28.8899 14.3652 28.6947 14.1699ZM13.4707 22.7939L10.7126 29.0667C10.6389 29.2341 10.8102 29.4044 10.9772 29.3298L17.1427 26.5752L25.1766 18.4342L21.6285 15.0044C21.5504 14.9288 21.4262 14.9295 21.3489 15.0059L13.4707 22.7939Z"
        fill="#3E4685"
      />
    </svg>
  )
}
